<template>
	<div id="teacherCheck">
		<index>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>基础配置</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/statement' }">报表中心</el-breadcrumb-item>
				<el-breadcrumb-item><a style="color: #000000;">教师请假报表</a></el-breadcrumb-item>
			</el-breadcrumb>
			<div class="content">
				<div class="u-f-item u-f-jsb" style="padding-right: 15px;border-bottom: 1px solid #EEEEEE;">
					<div class="title">共{{ total }}条数据</div>
					<el-button size="mini" type="primary" @click="teacherDerive">导出</el-button>
				</div>
				<div style="padding:0 15px;">
					<el-table ref="multipleTable" :data="List" tooltip-effect="dark" style="width: 100%;height: 73vh;">
						<el-table-column type="index" label="序号" width="150" align="center"></el-table-column>
						<el-table-column label="姓名" align="center" prop="username"></el-table-column>
						<el-table-column label="性别" prop="leave" align="center">
							<template slot-scope="scope">
								<div>
									{{scope.row.gender==1?'男':'女'}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="mobile" label="电话" align="center"></el-table-column>
						<el-table-column label="请假天数" prop="leave" align="center"></el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<router-link tag="a" target="_blank" :to="{name:'teacherCheckDetails',query:{id: scope.row.id,username:scope.row.username}}">
									<el-button type="text" size="small">查看</el-button>
								</router-link>
							</template>
						</el-table-column>
					</el-table>
					<div class="u-f-right" style="padding: 15px 0;">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page.sync="page"
							:page-size="limit"
							layout="total, prev, pager, next"
							:total="total"
						></el-pagination>
					</div>
				</div>
			</div>
		</index>
	</div>
</template>

<script>
import Progress from 'easy-circular-progress';
import index from '@/components/common/index.vue';
export default {
	components: {
		Progress,
		index
	},
	props: {},
	data() {
		return {
			page: 1,
			limit:13,
			total: 0,
			List: []
		};
	},
	mounted() {
		this.initData();
	},
	methods: {
		// 性别筛选
		filtersex(row, column) {
			return row.sex;
		},
		// 学科筛选
		filtersubject(row, column) {
			return row.subject;
		},
		// 班级筛选
		filterclasses(row, column) {
			return row.classes;
		},
		// 性质筛选
		filternature(row, column) {
			return row.nature;
		},
		// 职称筛选
		filterrank(row, column) {
			return row.rank;
		},
		// 工资筛选
		filtersalary(row, column) {
			return row.salary;
		},
		// 身份筛选
		filteridentity(row, column) {
			return row.identity;
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.page = val;
			this.initData();
			console.log(`当前页: ${val}`);
		},
		initData() {
			this.$api.teachers
				.teacherstatement({
					page: this.page,
					limit: this.limit
				})
				.then(res => {
					if (res.data.code == 1) {
						let list = res.data.data.rows;
						this.total = res.data.data.total;
						this.List = list;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		teacherDerive(){
			this.$api.teachers.teacherLeaveDerive({}).then(res=>{
				if(res.data.code==1){
					location.href = res.data.data.url;
				}
			})
		},
		toDetails(id){
			
		}
	}
};
</script>

<style lang="scss">
#teacherCheck {
	.head {
		background-color: #ffffff;
		padding: 8px 20px;
		margin-top: 15px;
		.main-tab-bars {
			border: 1px solid #dadfe0;
			.main-tab-item {
				height: 30px;
				line-height: 30px;
				width: 100px;
				text-align: center;
				cursor: pointer;
				-webkit-touch-callout: none;
				-webkit-user-select: none;
				-khtml-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			}
			.active {
				color: #67adf4;
				background-color: #e1f3ff;
				border: 1px solid #67adf4;
			}
		}
	}
	.main-item {
		background: #ffffff;
		margin-top: 15px;
		.title {
			padding: 15px;
			font-weight: bold;
			font-size: 16px;
			color: #4e4e4e;
			border-bottom: 1px solid #fafafb;
		}
	}
	.content {
		background-color: #ffffff;
		margin-top: 15px;
		height: 85vh;
		overflow: hidden;
		.title {
			padding: 15px;
			font-weight: bold;
			font-size: 16px;
		}
	}
	.el-table th > .cell,
	.el-table .cell {
		overflow: hidden; /*超出部分隐藏*/
		white-space: nowrap; /*不换行*/
		text-overflow: ellipsis; /*超出部分文字以...显示*/
	}
	.vue-circular-progress .circle__progress {
		stroke-linecap: square;
	}
	.el-dialog__header {
		border-bottom: 1px solid #eeeeee;
		padding: 10px 20px;
		.el-dialog__title {
			font-size: 16px;
		}
	}
	.el-dialog__body {
		padding: 20px;
		.el-radio {
			margin-bottom: 10px;
			margin-top: 10px;
		}
	}
	.el-dialog__footer {
		border-top: 1px solid #eeeeee;
		text-align: center;
	}
	.el-table__column-filter-trigger {
		.el-icon-arrow-down:before {
			content: '\E790';
			font-size: 16px;
		}
	}
}
</style>
